import $ from "@modules/jquery";

export function initMenuAccordion() {
    $('.menu-accordion .accordion-head').each((i, el) => {
        $(el).on('click', () => {
            const accordion = $(el).parent();
            const button = $(el).find('button[aria-expanded]');
            const body = $(el).next('.accordion-body');
            const container = $(el).closest('.menu-accordion');

            const isOpen = accordion.hasClass('active');

            // Chiude tutto prima
            container.find('.accordion-item').removeClass('active');
            container.find('.accordion-body').slideUp(300);
            container.find('button[aria-expanded]').attr('aria-expanded', 'false');

            if (!isOpen) {
                accordion.addClass('active');
                body.slideDown(300);
                button.attr('aria-expanded', 'true');
            }
        });
    });
}
